import { render, staticRenderFns } from "./OficinasTreinamentos.vue?vue&type=template&id=a3cfdaec"
import script from "./OficinasTreinamentos.vue?vue&type=script&lang=js"
export * from "./OficinasTreinamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports